<script>
  import * as d3 from "d3";
  import { draw, fade } from "svelte/transition";

  export let type = "line";
  // export let d;
  export let data = [];
  export let xAccessor = () => {};
  export let yAccessor = () => {};
  export let y0Accessor = 0; // For area chart
  export let interpolation = d3.curveMonotoneX;
  export let strokeWidth = 1;
  export let strokeOpacity = 1;
  export let stroke = "var(--grey)";
  export let strokeDasharray = null;
  export let style = "";
  export let transform = null;

  // let line;
  // $: if (d) {
  //   line = d;
  // } else {
  //   const lineGenerator = d3[type]()
  //     .x(xAccessor)
  //     .y(yAccessor)
  //     .curve(interpolation)
  //     .defined((d) => yAccessor(d));

  //   if (type == "area") {
  //     lineGenerator.y0(y0Accessor).y1(yAccessor);
  //   }
  //   line = lineGenerator(data);
  // }

  $: lineGenerator = d3[type]()
    .x(xAccessor)
    .y(yAccessor)
    .curve(interpolation)
    .defined((d) => yAccessor(d));

  $: {
    if (type == "area") {
      lineGenerator.y0(y0Accessor).y1(yAccessor);
    }
  }

  $: line = lineGenerator(data);
</script>

<path
  in:draw={{ duration: 3000 }}
  class={`Line Line--type-${type}`}
  d={line}
  {style}
  stroke-width={strokeWidth}
  stroke-opacity={strokeOpacity}
  {stroke}
  stroke-dasharray={strokeDasharray}
  {transform}
/>

<style>
  .Line {
    transition: stroke-width 0.3s ease-out, stroke-opacity 0.3s ease-out,
      d 0.3s ease-out, transform 0.3s ease-out;
    pointer-events: none;
  }

  .Line--type-line {
    /* stroke: var(--purple); */
    /* stroke-linecap: round; */
    fill: none;
  }

  .Line--type-area {
    fill: hsla(252, 92%, 74%, 0.185);
    stroke-width: 0;
  }
</style>
